import { createContext, useContext } from 'react';

import { WebserviceProblemProps } from './types';

const webservicePropsContext = createContext({} as WebserviceProblemProps);

export const WebservicePropsProvider = webservicePropsContext.Provider;

export function useWebserviceProblemProps() {
    return useContext(webservicePropsContext);
}

// try https://github.com/dai-shi/use-context-selector
export function useWebservicePropsSelector<T>(selector: (state: WebserviceProblemProps) => T): T {
    return selector(useWebserviceProblemProps());
}
